const toIsoDate = (date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
    date.getDate()
  ).padStart(2, "0")}`;

const dateForYear = (year, day, month) => {
  const lastDay = new Date(year, month, 0).getDate();
  return new Date(year, month - 1, Math.min(day, lastDay));
};

export function formatIsoUk(iso) {
  if (!iso || !/^\d{4}-\d{2}-\d{2}$/.test(iso)) return iso || "";
  const [year, month, day] = iso.split("-");
  return `${day}/${month}/${year}`;
}

export function fiscalYearLabel(year) {
  if (!year?.start_date || !year?.end_date) return "";
  return `${formatIsoUk(year.start_date)} to ${formatIsoUk(year.end_date)}`;
}

/** 12-month period ending the day before the next anniversary. */
export function suggestedFiscalYearDates(startDay, startMonth, existingYears = []) {
  if (!startDay || !startMonth) return { start_date: "", end_date: "" };

  const today = new Date();
  const day = Number(startDay);
  const month = Number(startMonth);
  const existingStartDates = new Set(existingYears.map((year) => year.start_date));
  let year = today.getFullYear();
  if (dateForYear(year, day, month) > today) year -= 1;
  while (existingStartDates.has(toIsoDate(dateForYear(year, day, month)))) year += 1;

  const start = dateForYear(year, day, month);
  const end = dateForYear(year + 1, day, month);
  end.setDate(end.getDate() - 1);
  return { start_date: toIsoDate(start), end_date: toIsoDate(end) };
}

export function fiscalYearClash(startDate, endDate, existingYears = [], ignoreId = null) {
  if (!startDate || !endDate) return "Start and end dates are required.";
  if (endDate <= startDate) return "The end date must be after the start date.";

  for (const year of existingYears) {
    if (ignoreId != null && String(year.id) === String(ignoreId)) continue;
    if (year.start_date === startDate) {
      return `A financial year starting ${formatIsoUk(startDate)} already exists.`;
    }
    const overlaps = startDate <= year.end_date && endDate >= year.start_date;
    if (overlaps) {
      return `These dates overlap ${formatIsoUk(year.start_date)} to ${formatIsoUk(year.end_date)}.`;
    }
  }
  return "";
}

export function defaultBudgetName(fiscalYear) {
  if (!fiscalYear?.start_date || !fiscalYear?.end_date) return "Service charge budget";
  return `Service charge budget ${fiscalYear.start_date.slice(0, 4)}/${fiscalYear.end_date.slice(0, 4)}`;
}
